import { Component, OnInit, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalData } from 'digital-core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalComponent, } from 'common';


@Component({
  selector: 'gsp-yes-no-modal',
  templateUrl: './yes-no-modal.component.html',
  styleUrls: ['./yes-no-modal.component.scss']
})
export class YesNoModalComponent implements OnInit {
  public selectedOption: any = String(false);

  constructor(public thisDialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalData) {
    thisDialogRef.disableClose = true;
  }

  ngOnInit(): void {
 
  }

  onClose() {
    // get selected option 
    this.thisDialogRef.close(this.selectedOption);
  }
 

}
